import React, { useState, useEffect } from 'react';
import ObjectMerge from 'object-merge';
import Button from "s2s-button";
import Input from "s2s-input";
import RadioInput from "../radioInput";
import Select from 's2s-select';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import { getIntlText, phoneNumberValidation } from '../../js/utilities';
import useContacts from "../../hooks/contacts";
import useAlerts from '../../hooks/alerts';
import { track } from 's2s-app-service';

const FormScreen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content : space-between;
`;

const FormScreenHeader = styled.div`
  align-items: center;
  background-color: #182661;
  display: flex;
  flex-direction: row;
  height : 56px;
  justify-content: center;
  position: relative;
`;

const FormScreenHeaderParagraph = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  align-items: center;
  color: ${colorGrid.gray0};
  display: flex;
  letter-spacing: 0.1px;
`;

// const FormErrorBar = styled.div`
//   background-color: ${colorGrid.red8};
//   color: ${colorGrid.gray0};
//   display: ${props => props.hasError ? 'block' : 'none'}
//   font-size: 12px;
//   line-height: 24px;
//   letter-spacing: 0.1px;
//   padding: 5px;
//   text-align: center; 
// `;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionHeader = styled.div`
  align-items : center;
  background-color: #F2F2F3;
  color: ${colorGrid.gray6};
  display: flex;
  font-size: 12px;
  font-weight: 600;
  height: 24px;
  line-height: 16px;
  text-align: left;
  width: 100%;
`;

const SectionText = styled.span`
  padding-left: 16px;
  color: #33414D;
`;

const FormArea = styled.div`
  padding : 0px 16px 24px 16px;
  background-color: #FFF;
`;
const FormInput = styled(Input)`
  width : 100%;
  margin: 0;
  padding: 0;
  
  & > label > div.Information {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #192936;
  }
  & > label > div.RelativeInputPreviewContainer > input {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;

const PhoneInput = styled(Input)`
  width : 100%;
  & > label > div.Information {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #192936;
  }

  .ErrorContainer {
    width : calc(100% - 80px);
  }
`;

const FormRow = styled.div`
  display : flex;
  margin-top : 16px;
`;

const PhoneNumberContainer = styled.ul`
  list-style: none;
  padding: 0px;
  margin: 0px;
`;

const PhoneNumberItem = styled.li`
  border-bottom: 1px solid ${colorGrid.gray3};
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;
  padding-top : 16px;
`;

const PhoneNumberLITop = styled.div`
  display: flex;
  align-items: center;
  div {
    margin-right: 0.5em;
  }
  div:last_child {
    margin-right: 0;
  }
`;

const PhoneNumberLIBottom = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0;
`;

const FormSelect = styled(Select)`
  line-height: 22px;
  
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  label.SelectLabel {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #192936;
  }

  @media(max-width: 381px){
    margin-right: 0px; 
  }

`;

const PhoneInputContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  div.RelativeInputPreviewContainer, div.Information, div.ContactFormInput {
    margin: 0;
  }
  div.Information {
    margin-bottom: 8px;
  }
`;

const PhoneSelectContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  padding: 0;

  div {
    margin: 0;
  }

  @media(max-width: 381px){
    margin-right: 0px;
  }

  .react-select__option--is-selected {
    color: #243991;
    background: rgba(36, 57, 145, 0.08);
  }
  .react-select__option--is-focused {
    background: rgba(36, 57, 145, 0.04);
    cursor: pointer;
  }
`;

const RemoveButton = styled(Button)`
  align-items : center;
  background-color: transparent;
  display : flex;
  height: 40px;
  justify-content : center;
  width: 40px;
  padding : 0px;
  margin-top: 1.8rem;
  :hover {
    background-color: rgba(36, 57, 145, 0.04);
  }
  svg {
    position: relative;
    left: 8px;
  }
`;

const PhoneRadioStyle = styled.label`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 92px;
`;

const LabelStyle = styled.p`
  color: ${colorGrid.gray9};
  display: flex;
  font-size: 12px;
  font-weight: 600;
  height: 16px;
  line-height: 1.33;
  letter-spacing: 0.1px;
  margin: 0px;
  padding: 8px 0px 8px 0px;
  text-align: left;
`;

const AddPhoneButton = styled(Button)`
  background-color: #FFF;
  border: 1px solid #A7B4E9;
  border-radius: 4px;
  margin: 24px 0px 24px 0px;
  & > div {
    color: #243991;
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
  }
  &:hover {
    background-color: #D3D9F4;
  }
`;

const FormScreenFooter = styled.div`
  align-items: center;
  background-color: ${colorGrid.gray0};
  border-top: ${'1px solid ' + colorGrid.gray4};
  display: flex;
  flex-direction: row;
  height : 56px;
  justify-content: flex-end; 
  margin-top: auto;
`;

const SaveButton = styled(Button)`
  height: 40px;
  margin-right: 16px;
  padding: 10px 25px;
  text-transform : uppercase;
  background-color: #243991;
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  :hover {
    background-color: #182661;
  }
`;

const CancelButton = styled(SaveButton)`
  background-color: transparent;
  color: #243991;
  :hover {
    background-color: #D3D9F4;
  }
`;

const FormScreenBody = styled.div`
  background-color: #FFF;
  height : calc(100vh - 104px); // app header, form header, form footer = 160px
  overflow : auto;
`;

const contactDetailsTemplate = {
  phone_numbers: [{
    type: 'Home',
    number: '',
    preferred: false
  }],
  work: {
    company: ''
  },
  name: {
    first: '',
    last: ''
  }
};

const ContactFormInput = (props) => {

  const handleBlur = (value) => {
    return props.cbOnBlur(props.property, value, props.index);
  };

  const handleChange = (value) => {
    return props.cbOnChange(props.property, value, props.index);
  };

  let DynamicStyledInput = props.styledClass; // I have a few different styled components for input and this helps me render the correct one.

  return (
    <DynamicStyledInput
      className={props.className}
      autoFocus={props.autoFocus}
      cbOnChange={handleChange}
      cbOnBlur={handleBlur}
      errorText={props.errorText}
      hasError={props.hasError}
      isDisabled={props.isDisabled}
      inputLabel={props.inputLabel}
      property={props.property}
      value={props.value}
    />
  );
};

ContactFormInput.propTypes = {
  autoFocus: PropTypes.bool,
  cbOnChange: PropTypes.func,
  cbOnBlur: PropTypes.func,
  errorText: PropTypes.string,
  hasError: PropTypes.bool,
  index: PropTypes.number,
  isDisabled: PropTypes.bool,
  inputLabel: PropTypes.string,
  property: PropTypes.string,
  styledClass: PropTypes.object, // styled component class defined immediately above
  value: PropTypes.string
};

ContactFormInput.defaultProps = {
  hasError: false,
  styledClass: FormInput,

};

const ContactFormSelect = (props) => {

  const handleValueChange = (value) => {
    return props.cbOnValueChange(props.property, value.value, props.index);
  };

  //console.log("CONTACT FORM SELECT: selectLabel, property", props.selectedItem);
  return (
    <FormSelect
      className="FormSelect"
      cbOnValueChange={handleValueChange}
      //cbOnBlur={handleBlur}
      selectLabel={props.selectLabel}
      menuItems={props.menuItems}
      placeholder={props.placeholder}
      showSelectLabel={props.showSelectLabel}
      isDisabled={props.isDisabled}
      selectedItem={props.selectedItem}
      property={props.property}
      hasError={props.hasError}
      errorText={props.errorText}
    />
  );
};

ContactFormSelect.propTypes = {
  cbOnBlur: PropTypes.func,
  cbOnValueChange: PropTypes.func,
  errorText: PropTypes.string,
  hasError: PropTypes.bool,
  index: PropTypes.number,
  isDisabled: PropTypes.bool,
  menuItems: PropTypes.array,
  placeholder: PropTypes.string,
  //property : PropTypes.object, // 
  property: PropTypes.string,
  selectedItem: PropTypes.string,
  selectLabel: PropTypes.string,
  showSelectLabel: PropTypes.bool,
};

ContactFormSelect.defaultProps = {
  cbOnBlur: () => { },
  menuItems: [],
  selectedItem: "Home"

};

const ContactDetailsForm = (props) => {
  const [, currentContact, , { getContact }] = useContacts();

  let initialFormValues = ObjectMerge({}, contactDetailsTemplate);

  const [formValues, setFormValues] = useState(initialFormValues);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [phoneNumberErrorIndex, setPhoneNumberErrorIndex] = useState([]);
  const [, { createErrorAlert }] = useAlerts();

  useEffect(() => {
    getContact(props.contactUUID, props.intl);
  }, []); // NOTE : this useEffect function only fires for the initial render. - KCN

  useEffect(() => {
    if (currentContact !== undefined) {
      initialFormValues = ObjectMerge({}, contactDetailsTemplate, currentContact); // NOTE : Avoiding calling setState hook within conditional so just setting it's argument within conditional - KCN
    }
    setFormValues(initialFormValues);
  }, [currentContact]); // NOTE : this useEffect function watches for any changes in currentContact - KCN

  const updateRadioButtons = (selectedIndex) => {
    // will update all radiobuttons
    let newPhoneNumber = formValues && formValues.phone_numbers.map((phoneItem, itemIndex) => {
      if (itemIndex === selectedIndex) {
        phoneItem.preferred = true;
      } else {
        phoneItem.preferred = false;
      }

      return phoneItem;
    });

    formValueChange("phone_number", newPhoneNumber, 0, false, formValues);
  };

  const editPhoneNumber = (property, value, index) => {

    let returnState = ObjectMerge({}, formValues);
    returnState.phone_numbers[index][property] = value;

    // clear the error since it may have been fixed.  If still bad it will be flagged again when save clicked
    setPhoneNumberErrorIndex(phoneNumberErrorIndex.filter(errorIndex => errorIndex !== index));

    setFormValues(returnState);
  };

  const renderPhoneNumber = (index, phoneItem) => {
    // function renders the phone number List Item

    const selectData = [
      { label: getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SELECT-HOME', 'Home'), value: "Home" },
      { label: getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SELECT-BUSINESS', 'Business'), value: 'Business' },
      { label: getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SELECT-MOBILE', 'Mobile'), value: 'Mobile' },
      { label: getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SELECT-OTHER', 'Other'), value: 'Other' }
    ];

    return (
      <PhoneNumberItem className='phoneNumberLI' key={"phone" + index}>
        <PhoneNumberLITop className='phoneNumberLITop' >
          <PhoneSelectContainer className="PhoneSelectContainer">
            <ContactFormSelect
              className="ContactFormSelect"
              selectLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SELECT-LABEL', 'Label')}
              cbOnValueChange={editPhoneNumber}
              index={index}
              isDisabled={false}
              itemsVisible={4}
              menuItems={selectData}
              placeholder=""
              property="type"
              selectedItem={phoneItem.type}
            />
          </PhoneSelectContainer>
          <PhoneInputContainer>
            <ContactFormInput
              className="ContactFormInput"
              inputLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-NUMBER-LABEL', 'Number')}
              autoFocus={false}
              cbOnBlur={editPhoneNumber}
              cbOnChange={editPhoneNumber}
              errorText={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-NUMBER-ERROR', 'Please enter a valid digit number')}
              hasError={phoneNumberErrorIndex.includes(index)}
              index={index}
              styledClass={PhoneInput}
              placeholder={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER', 'Enter Number...')}
              property="number"
              value={phoneItem.number}
            />
          </PhoneInputContainer>
          <RemoveButton
            className="RemoveButton"
            ariaLabel={'remove phone Number'}
            buttonLabel={''}
            buttonType="secondary"
            cbClick={() => { removeItemFromPhoneNumberArray(index); }}
            isDisabled={false}
            svgType={'MdDelete'}
            svgFill="#888"
          />
        </PhoneNumberLITop>
        <PhoneNumberLIBottom className='phoneNumberLIBottom'>
          <PhoneRadioStyle className='phoneNumberLabel' >
            <RadioInput
              className="RadioInput"
              cbChanged={() => { updateRadioButtons(index); }}
              isChecked={phoneItem.preferred}
              name={'preferredNumber'}
              value={`${index}`}
            />
            <LabelStyle className='labelParagraph' >
              {getIntlText(props.intl, 'CONTACT-DETAILS-FORM-PREFERRED-LABEL', 'Preferred?')}
            </LabelStyle>
          </PhoneRadioStyle>
        </PhoneNumberLIBottom>
      </PhoneNumberItem>
    );
  };

  const renderPhoneNumberList = (formValues = {}) => {
    //console.log("formValues", formValues );
    // function renders the phone number unordered list
    const currentPhoneList = formValues.phone_numbers !== undefined ? formValues.phone_numbers : [];
    return (
      <PhoneNumberContainer className='PhoneNumber'>
        {currentPhoneList.map((phoneNumberItem, index) => {
          return renderPhoneNumber(index, phoneNumberItem);
        })}
      </PhoneNumberContainer>
    );
  };

  const addItemToPhoneNumberArray = () => {
    // function adds an empty phone number object to the Array
    let returnState = ObjectMerge({}, formValues);

    if (returnState.phone_numbers) {
      returnState.phone_numbers.push({
        type: 'Home',
        number: '',
        preferred: false
      });
    } else {

      returnState.phone_numbers = [{
        type: 'Home',
        number: '',
        preferred: false
      }];
    }

    setFormValues(returnState);
  };

  const removeItemFromPhoneNumberArray = (indexToRemove) => {
    // function removes a phone number object from the array
    let returnState = ObjectMerge({}, formValues);
    returnState.phone_numbers.splice(indexToRemove, 1);
    setFormValues(returnState);
  };

  const validateForm = (values, save = false) => {
    //  function validates the values in the form

    //This is a gaurd on the phone values, ensuring an array is always returned
    const phoneArray = values.phone_numbers !== undefined ? values.phone_numbers : [];

    // Create an array of the phone array indices with an error (undefined or non-10 digit number)
    const phoneNumberErrorArray = phoneArray.reduce((accum, currPhone, index) => {
      if (currPhone.number === undefined || !phoneNumberValidation(currPhone.number)) {
        accum.push(index);
      }
      return accum;
    }, []);

    const phoneNumberErrorLength = phoneNumberErrorArray.length;
    //A group of ternaries which varify if an item exists
    //and meets requirements, if it does not, it marks it as having an error
    const firstNameError = !values.name.first || values.name.first.length < 1 ? true : false;
    const lastNameError = !values.name.last || values.name.last.length < 1 ? true : false;
    const phoneNumberErrorIndexArray = phoneNumberErrorLength >= 1 ? phoneNumberErrorArray : [];

    //If there are any errors then it will mark the form as having an Error.
    const hasError = firstNameError || lastNameError || (phoneNumberErrorArray && phoneNumberErrorArray.length >= 1);

    //if the form has an error update the state
    if (hasError === true) {
      createErrorAlert({
        message: getIntlText(props.intl, 'CONTACT-FORM-ERROR-TITLE', 'Form Validation Error'),
        details: [getIntlText(props.intl, 'CONTACT-FORM-ERROR-BODY', 'There is invalid data in this form.')],
        autoCloseTimeout: 10,
      });

      //setFormHasError(hasError);
      setFirstNameError(firstNameError);
      setLastNameError(lastNameError);
      setPhoneNumberErrorIndex(phoneNumberErrorIndexArray);
    } else {
      //if the form does not have an error, pass the contact details to the parent and clean the state of errors
      // setFormHasError(false);
      setFirstNameError(false);
      setLastNameError(false);
      setPhoneNumberErrorIndex([]);

      const newOrEdit = props.isNewContact ? 'add' : 'update';
      if (save === true) {
        props.cbSaveDetails(values, newOrEdit);
      }
    }
  };

  const formValueChange = (property, value, index, doValidation) => {
    let returnState = ObjectMerge({}, formValues);

    // if property is in root of formValues...
    if (typeof returnState[property] !== "undefined") {
      returnState[property] = value;
    } else {
      // if property is in address prop of formValues

      if (typeof returnState.name[property] !== "undefined") {
        returnState.name[property] = value;
      } else if (typeof returnState.work[property] !== "undefined") {
        returnState.work[property] = value;
      }
    }

    setFormValues(returnState);

    if (doValidation) {
      validateForm(formValues, false);
    }
  };

  const cancelClicked = () => {
    /* this function passes the appropriate call back to the parent when cancel is clicked */
    props.cbCancelDetailEdit();

    // setFormHasError(false);
    setPhoneNumberErrorIndex([]);
    setFirstNameError(false);
    setFormValues(ObjectMerge({}, contactDetailsTemplate, currentContact));
  };

  const formHeaderText = props.isNewContact ?
    getIntlText(props.intl, 'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER', 'New Contact') :
    getIntlText(props.intl, 'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER', 'Edit Contact');

  return (
    <FormScreen className="ContactDetailsFormContainer">
      <FormScreenBody className="FormScreenBody">
        <FormScreenHeader className="FormScreenHeader">
          <FormScreenHeaderParagraph className='formScreenHeaderParagraph'  >
            {formHeaderText}
          </FormScreenHeaderParagraph>
        </FormScreenHeader>
        <SectionContainer>
          <SectionHeader>
            <SectionText>
              {getIntlText(props.intl, 'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER', 'Personal Information')}
            </SectionText>
          </SectionHeader>
          <FormArea className="FormArea">
            <FormRow className="FormRow">
              <ContactFormInput
                className="ContactFirstNameInput"
                autoFocus={false}
                cbOnBlur={formValueChange}
                cbOnChange={formValueChange}
                errorText={firstNameError ? getIntlText(props.intl, 'CONTACT-FORM-INPUT-FIRST-NAME-ERROR', "First name required to create contact") : undefined}
                hasError={firstNameError}
                inputLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER', 'First Name')}
                property="first"
                value={formValues.name.first}
              />
            </FormRow>
            <FormRow>
              <ContactFormInput
                className="ContactLastNameInput"
                autoFocus={false}
                cbOnBlur={formValueChange}
                cbOnChange={formValueChange}
                errorText={lastNameError ? "Last name required to create contact." : undefined}
                hasError={lastNameError}
                inputLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-LAST-NAME-HEADER', 'Last Name')}
                property="last"
                value={formValues.name.last}
              />
            </FormRow>
            <FormRow className="FormRow">
              <ContactFormInput
                className="ContactLastNameInput"
                autoFocus={false}
                cbOnBlur={formValueChange}
                cbOnChange={formValueChange}
                inputLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER', 'Company')}
                property="company"
                value={formValues.work.company}
              />
            </FormRow>
          </FormArea>
        </SectionContainer>
        <SectionContainer>
          <SectionHeader className="SectionHeader">
            <SectionText className="SectionText">
              {getIntlText(props.intl, 'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER', 'Phone Numbers')}
            </SectionText>
          </SectionHeader>
          <FormArea className="FormArea">
            {renderPhoneNumberList(formValues)}
            <AddPhoneButton
              className="addPhone"
              ariaLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL', 'Add Phone')}
              buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL', 'Add Phone')}
              buttonType="primaryGreen"
              cbClick={addItemToPhoneNumberArray}
            />
          </FormArea>
        </SectionContainer>
      </FormScreenBody>
      <FormScreenFooter>
        <CancelButton
          className="CancelButton"
          ariaLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL', 'Cancel')}
          buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL', 'Cancel')}
          buttonType="secondary"
          cbClick={cancelClicked}
        />
        <SaveButton
          className="SaveButton"
          ariaLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL', 'Save')}
          buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL', 'Save')}
          buttonType="primaryGreen"
          cbClick={() => { track("edit_add_contact_save", "clicked"); validateForm(formValues, true); }}
        />
        
      </FormScreenFooter>

    </FormScreen>
  );
};

ContactDetailsForm.propTypes = {
  cbCancelDetailEdit: PropTypes.func,
  cbSaveDetails: PropTypes.func,
  contactUUID: PropTypes.string,
  intl: PropTypes.object,
  isNewContact: PropTypes.bool
};

ContactDetailsForm.defaultProps = {
  cbCancelDetailEdit: () => { },
  cbSaveDetails: () => { },
  contactUUID: ""
};


export default ContactDetailsForm;
